import axios from "axios";

const state = () => ({
  data: [],
  loading_is_complete: false,
  product_ids: [],
  filters: {}, //brend: ["enum_id_261", "enum_id_262"], produkt: ["enum_id_1004"]
  view_products: [],
  on_page: 48,
  current_page: 1,
  count_pages: 1,
  next_page: 2,
  prev_page: 0,
  viewtype: "grid",
  sort2: "sort",
  sort3: "price_flat",
  sort4: "quantity_flat",
  sort: "price_value",
  sort_direction: "asc",
  search_text: [],
  show_filters: false,
  show_subcategory: true,
  max_price: null,
  min_price: null,
});

const actions = {
  FETCH_GROUP: ({ commit, dispatch }, slug) => {
    commit("SET_LOADING_IS_COMPLETE", false);
    let slug2 = slug.split('-').join('_');
    axios
      .get(`${process.env.VUE_APP_API_URL}groups/${slug2}`)
      .then(function (response) {
        // console.log(response.data)
        // console.log("FETCH_GROUP")

        commit("SET_LOADING_IS_COMPLETE", true);
        commit("SET_DATA", response.data);
        dispatch("UPDATE");

        dispatch(
          "bread_crumbs/SET_FOR_GROUP",
          {
            slug: slug,
            name: response.data.name,
            parent: response.data.parent,
          },
          { root: true }
        );
      })
      .catch(function (error) {
        commit("SET_LOADING_IS_COMPLETE", false);
        console.log(error);
      });
  },

  UPDATE: ({ commit }) => {
    commit("FILTER_PRODUCT");
    commit("FILTER_PRODUCT_BY_PRICE");
    commit("SEARCH_BY_TEXT_PRODUCT");
    commit("SET_VIEW_PRODUCTS");
    commit("SORT_VIEW_PRODUCTS");
    commit("SET_MIN_MAX_PRICE");
    commit("SET_NEXT_PREV_PAGE");
    commit("SET_AVAILABLE_FILTERS");
  },

  SET_CURRENT_PAGE: ({ commit }, page) => {
    commit("SET_CURRENT_PAGE", page);
    commit("SET_NEXT_PREV_PAGE");
  },

  PREV_PAGE: ({ commit, state }) => {
    if (state.current_page > 1) {
      let page = state.current_page - 1;
      commit("SET_CURRENT_PAGE", page);
      commit("SET_NEXT_PREV_PAGE");
    }
  },

  NEXT_PAGE: ({ commit, state }) => {
    if (state.current_page < state.count_pages) {
      let page = state.current_page + 1;
      commit("SET_CURRENT_PAGE", page);
      commit("SET_NEXT_PREV_PAGE");
    }
  },

  SET_SORT: ({ commit }, { sort, sort_direction }) => {
    console.log("SET_SORT")
    console.log(sort,sort_direction)
    commit("SET_SORT", sort);
    commit("SET_SORT_DIRECTION", sort_direction);
    commit("SORT_VIEW_PRODUCTS");
  },

  SET_SEARCH: ({ commit, dispatch }, search_text) => {
    commit("SET_SEARCH_TEXT", search_text);
    // commit('CLEAR_VIEW_PRODUCTS')
    dispatch("UPDATE");
  },

  FILTER_BY_PRICE: ({ dispatch }) => {
    // console.log("FILTER_PRODUCT_BY_PRICE")
    dispatch("UPDATE");
  },

  CHANGE_CHECKED_FILTER: ({ commit, dispatch }, data) => {
    commit("CHANGE_CHECKED_FILTER", data);
    dispatch("UPDATE");
  },
};

const getters = {
  GET_LOADING_IS_COMPLETE: (state) => {
    return state.loading_is_complete;
  },

  GET_PROPERTIES: (state) => {
    if (state.data.all_properties) {
      return state.data.all_properties;
    } else {
      return [];
    }
  },

  GET_GROUP_INFO: (state) => {
    return {
      name: state.data.name,
      meta_title: state.data.meta_title,
      meta_description: state.data.meta_description,
    };
  },

  GET_PRODUCTS: (state) => {
    let start =
      parseInt(state.current_page) == 1
        ? 0
        : (parseInt(state.current_page) - 1) * state.on_page;
    let end = state.current_page * state.on_page;
    return state.view_products.slice(start, end);
  },

  GET_VIEWTYPE: (state) => {
    return state.viewtype;
  },

  GET_ON_PAGE: (state) => {
    return state.on_page;
  },

  GET_PRODUCTS_LENGTH: (state) => {
    return state.product_ids.length;
  },

  GET_CURRENT_PAGE: (state) => {
    return state.current_page;
  },

  GET_COUNT_PAGES: (state) => {
    return state.count_pages;
  },

  GET_NEXT_PAGE: (state) => {
    return state.next_page;
  },

  GET_PREV_PAGE: (state) => {
    return state.prev_page;
  },

  GET_SORT: (state) => {
    return state.sort;
  },
  GET_SORT_DIRECTION: (state) => {
    return state.sort_direction;
  },
  GET_SHOW_FILTERS: (state) => {
    return state.show_filters;
  },
  GET_SHOW_SUBCATEGORY: (state) => {
    return state.show_subcategory;
  },
  GET_SUB_GROUPS: (state) => {
    return state.data.sub_groups;
  },
  GET_MAX_PRICE: (state) => {
    return state.max_price;
  },
  GET_MIN_PRICE: (state) => {
    return state.min_price;
  },
};

const mutations = {
  SET_LOADING_IS_COMPLETE: (state, status) => {
    state.loading_is_complete = status;
  },

  CHANGE_SHOW_FILTERS: (state) => {
    return (state.show_filters = !state.show_filters);
  },

  SET_DATA: (state, data) => {
    state.filters = {};
    state.max_price = null;
    state.min_price = null;
    state.current_page = 1;
    state.data = data;

    //<<<Параметры из url
    let url = new URL(document.location.href);
    for (let [slug, enums] of url.searchParams) {
      if (
        Object.prototype.hasOwnProperty.call(
          state.data.properties_and_products,
          slug
        )
      ) {
        enums.split("-").forEach((enum_id) => {
          if (
            !Object.prototype.hasOwnProperty.call(
              state.data.properties_and_products[slug],
              enum_id
            )
          )
            return;
          if (Object.prototype.hasOwnProperty.call(state.filters, slug)) {
            let f = state.filters[slug];
            if (!f.includes(enum_id)) f.push(enum_id);
          } else {
            state.filters[slug] = [enum_id];
          }
        });
      } else {
        if (slug == "min_price") state.min_price = parseFloat(enums);
        if (slug == "max_price") state.max_price = parseFloat(enums);
        if (slug == "page") state.current_page = parseInt(enums);
      }
    }
    //Параметры из url>>>

    //<<< Установка выбранных фильтров
    for (let slug in state.filters) {
      state.data.all_properties.forEach((property) => {
        if (!property.slug == slug) return;
        property.property_values.forEach((p_enum) => {
          if (state.filters[slug].includes(String(p_enum.enum_id)))
            p_enum.checked = true;
        });
      });
    }
    //Установка выбранных фильтров >>>
  },

  CLEAR_VIEW_PRODUCTS: (state) => {
    state.view_products = [];
  },

  FILTER_PRODUCT: (state) => {
    // console.log("FILTER_PRODUCT")

    state.product_ids = [];

    if (Object.keys(state.filters).length == 0) {
      for (let key of Object.keys(state.data.products)) {
        state.product_ids.push(state.data.products[key].id);
      }
    } else {
      for (let property_key in state.filters) {
        let product_ids_for_this_property = [];
        state.filters[property_key].forEach((enum_id) => {
          if (
            Object.prototype.hasOwnProperty.call(
              state.data.properties_and_products[property_key],
              enum_id
            )
          ) {
            if (product_ids_for_this_property.length == 0) {
              product_ids_for_this_property = [
                ...state.data.properties_and_products[property_key][enum_id],
              ];
            } else {
              Array.prototype.push.apply(
                product_ids_for_this_property,
                state.data.properties_and_products[property_key][enum_id]
              );
            }
          }
        });

        if (state.product_ids.length == 0) {
          state.product_ids = [...product_ids_for_this_property];
        } else {
          state.product_ids = state.product_ids.filter((x) =>
            product_ids_for_this_property.includes(x)
          );
        }
      }
    }
  },

  FILTER_PRODUCT_BY_PRICE: (state) => {
    if (state.max_price == null && state.min_price == null) return;

    let max_price = state.max_price == null ? 0 : parseFloat(state.max_price);
    let min_price = state.min_price == null ? 0 : parseFloat(state.min_price);

    if (max_price < min_price) state.max_price = 0;

    let pids = [];
    for (let id of state.product_ids) {
      if (
        state.data.products[`pid_${id}`].price_value >= min_price &&
        (max_price == 0 ||
          state.data.products[`pid_${id}`].price_value <= max_price)
      ) {
        pids.push(id);
      }
    }
    if (state.product_ids.length == 0) {
      state.product_ids = [...pids];
    } else {
      state.product_ids = state.product_ids.filter((x) => pids.includes(x));
    }
  },

  SEARCH_BY_TEXT_PRODUCT: (state) => {
    if (state.search_text.length == 0) return;

    let pids = [];

    for (let id of state.product_ids) {
      let product = state.data.products[`pid_${id}`];
      if (helpers.product_have_search_text(state.search_text, product))
        pids.push(product.id);
    }

    if (state.product_ids.length == 0) {
      state.product_ids = [...pids];
    } else {
      state.product_ids = state.product_ids.filter((x) => pids.includes(x));
    }
  }, //SEARCH_BY_TEXT_PRODUCT

  SET_VIEW_PRODUCTS: (state) => {
    // console.log("SET_VIEW_PRODUCTS")
    state.view_products = [];
    state.count_pages = Math.ceil(state.product_ids.length / state.on_page);
    if (state.current_page > state.count_pages) state.current_page = 1;
    state.product_ids.forEach((pid) => {
      state.view_products.push(state.data.products[`pid_${pid}`]);
    });
  },

  SET_MIN_MAX_PRICE: (state) => {
    // let min_price = 99999999999
    // let max_price = 0

    state.view_products.forEach((p) => {
      // if (p.price_value < min_price) {
      if (p.price_value < state.min_price) {
        // min_price = p.price_value
        state.min_price = p.price_value;
      }

      // if (p.price_value > max_price) {
      if (p.price_value > state.max_price) {
        // max_price = p.price_value
        state.max_price = p.price_value;
      }
    });
    // if (state.view_products.length){
    //     state.min_price = min_price
    //     state.max_price = max_price
    // }

    // console.log(`${state.min_price} - ${state.max_price}`)
  },

  SORT_VIEW_PRODUCTS: (state) => {

    if (window.url_helpers.get_sort() === null) {
      state.view_products.sort((a, b) => {
        return b['price_flat'] - a['price_flat'] || b['quantity_flat'] - a['quantity_flat'] || a['sort'] - b['sort'] ||
          helpers.sortCompare(a[state.sort], b[state.sort], state.sort, state.sort_direction);
      });
    } else {
      state.view_products.sort((a, b) => {
        return b['price_flat'] - a['price_flat'] || b['quantity_flat'] - a['quantity_flat'] ||
          helpers.sortCompare(a[state.sort], b[state.sort], state.sort, state.sort_direction);
      });
    }
  },

  SET_VIEWTYPE: (state, vtype) => {
    state.viewtype = vtype;
  },

  SET_CURRENT_PAGE: (state, page) => {
    state.current_page = parseInt(page);
  },

  SET_NEXT_PREV_PAGE: (state) => {
    if (state.current_page < state.count_pages) {
      state.next_page = state.current_page + 1;
    } else {
      state.next_page = 0;
    }

    if (state.current_page > 1) {
      state.prev_page = state.current_page - 1;
    } else {
      state.prev_page = 0;
    }
  },

  SET_SORT: (state, sort) => {
    state.sort = sort;
  },

  SET_SORT_DIRECTION: (state, sort_direction) => {
    state.sort_direction = sort_direction;
  },

  SET_SEARCH_TEXT: (state, search_text) => {
    if (search_text == "") {
      state.search_text = [];
    } else {
      state.search_text = String(search_text)
        .toLowerCase()
        .replace(["ё"], ["е"])
        .split(" ");
    }
  },

  SET_MIN_PRICE: (state, min_price) => {
    state.min_price = min_price;
  },

  SET_MAX_PRICE: (state, max_price) => {
    state.max_price = max_price;
  },

  CHANGE_CHECKED_FILTER: (state, data) => {
    let enum_key = data.enum_id;
    if (Object.prototype.hasOwnProperty.call(state.filters, data.slug)) {
      let f = state.filters[data.slug];
      if (data.checked && !f.includes(enum_key)) {
        f.push(enum_key);
      }

      if (!data.checked && f.includes(enum_key)) {
        let i = f.indexOf(enum_key);
        f.splice(i, 1);
        if (f.length == 0) {
          delete state.filters[data.slug];
        }
      }
    } else {
      state.filters[`${data.slug}`] = [enum_key];
    }

    // console.log(state.filters)
  }, //CHANGE_CHECKED_FILTER

  SET_AVAILABLE_FILTERS: (state) => {
    // console.log("SET_AVAILABLE_FILTERS")

    state.data.all_properties.forEach((property) => {
      property.property_values.forEach((el) => (el.available = true));
    });

    if (Object.keys(state.filters).length == 0) return;

    for (let property_slug in state.filters) {
      // console.log(`Filter products by ${property_slug}`)

      for (let enum_id of state.filters[property_slug]) {
        let all_properties = helpers.get_all_properties(state, property_slug);

        for (let pid in state.data.products) {
          let product = state.data.products[pid];
          if (
            helpers.product_have_it_enum_id(product, property_slug, enum_id)
          ) {
            product.properties.forEach((property) => {
              if (
                property.property_slug != property_slug &&
                property.property_type == "list"
              ) {
                try {
                  all_properties[property.property_slug][
                    property.enum_id
                  ].available = true;
                } catch (e) {
                  // console.log(property)
                  // console.log(e.message)
                }
              }
            });
          }
        }
        for (let property of state.data.all_properties) {
          property.property_values.forEach((el) => {
            el.available =
              el.available &&
              all_properties[property.slug][el.enum_id].available;
          });
        }
      }

      state.data.all_properties.sort((a, b) => {
        if (a.available && !b.available) return -1;
        if (!a.available && !b.available) return 0;
        if (!a.available && b.available) return 1;
      });
    }
  }, //SET_AVAILABLE_FILTERS
};

const helpers = {
  sortCompare(a,b, sort='price-value', sortdir='asc') {
    if (sort == 'name') {
      return sortdir == 'asc' ? a.localeCompare(b) : b.localeCompare(a);
    } else {
      return sortdir == 'asc' ? a- b : b-a;
    }
  },
  product_have_search_text(search_phrases, product) {
    let name = product.name.toString().toLowerCase().replace(["ё"], ["е"]);
    let search_text = product.search_text
      .toString()
      .toLowerCase()
      .replace(["ё"], ["е"]);
    let article = product.article
      .toString()
      .toLowerCase()
      .replace(["ё"], ["е"]);
    let code_1c = product.code_1c.toString();
    let add_product = true;
    search_phrases.forEach((text) => {
      let rtext = window.keyboard_replacer.reverse(text);
      let rqtext = window.keyboard_replacer.reverse_q(text);

      if (
        !(
          name.includes(text) ||
          name.includes(rtext) ||
          name.includes(rqtext) ||
          search_text.includes(text) ||
          search_text.includes(rtext) ||
          search_text.includes(rqtext) ||
          code_1c.startsWith(text) ||
          article.includes(text)
        )
      ) {
        add_product = false;
      }
      // if (text != ""
      //     && !name.includes(text)
      //     && !search_text.includes(text)
      //     && !code_1c.startsWith(text)
      //     && !article.includes(text)
      // ) {
      //     add_product = false
      // }
    });
    return add_product;
  },
  product_have_it_enum_id(product, property_slug, enum_id) {
    let product_property = product.properties.find(
      (el) => el.property_slug == property_slug
    );
    if (product_property !== undefined && enum_id == product_property.enum_id) {
      return true;
    } else {
      return false;
    }
  },
  get_all_properties(state, property_slug) {
    let all_properties = {};
    for (let property of state.data.all_properties) {
      all_properties[property.slug] = {};
      property.property_values.forEach((el) => {
        all_properties[property.slug][el.enum_id] = {
          enum_id: el.enum_id,
          enum_value: el.enum_value,
          available: property.slug == property_slug,
        };
      });
    }
    return all_properties;
  },
  // product_have_it_enum_id(product, property_slug, enums) {
  //     let product_property = product.properties.find(el => el.property_slug == property_slug)
  //     if (product_property !== undefined
  //         && enums.find(el => el == product_property.enum_id) !== undefined) {
  //         return true
  //     } else {
  //         return false
  //     }
  // },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  helpers,
};
